import React from 'react'
import PropTypes from 'prop-types'
import { Alert, Paper, Stack, Typography } from '@mui/material'

export default function OperationalAlertList({ alerts = [] }) {
  return (
    <Paper variant="outlined" sx={{ p: 2.5, borderRadius: 3, height: '100%' }}>
      <Stack spacing={2}>
        <div>
          <Typography variant="h6" sx={{ fontWeight: 700 }}>
            Alertas operativas
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Priorización basada en layouts detectados y disponibilidad de catálogos.
          </Typography>
        </div>

        <Stack spacing={1.5}>
          {alerts.map((alert) => (
            <Alert key={`${alert.severity}-${alert.title}`} severity={alert.severity} variant="outlined">
              <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
                {alert.title}
              </Typography>
              <Typography variant="body2">{alert.description}</Typography>
            </Alert>
          ))}
        </Stack>
      </Stack>
    </Paper>
  )
}

OperationalAlertList.propTypes = {
  alerts: PropTypes.arrayOf(
    PropTypes.shape({
      severity: PropTypes.string,
      title: PropTypes.string,
      description: PropTypes.string,
    })
  ),
}
